
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Project {
    /**
    * 获取询价列表
    */
    export var getList = (query: any): Promise<any> => {
        return Get(`/msls/Project/getList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取询价详情
    */
    export var GetDetail = (ProjectId: string): Promise<any> => {
        return Get(`/msls/Project/GetDetail/${ProjectId}`, {});
    };
    /**
     * 编辑
     */
    export var EditProject = (id: string, body: any): Promise<any> => {
        return Put(`/msls/Project/Edit/${id}`, body);
    };
    /**
    * 删除
    */
    export var DelProject = (id: string): Promise<any> => {
        return Delete(`/msls/Project/Delete/${id}`, {});
    };
    /**
     * 终结
     */
    export var EndProject = (id: string): Promise<any> => {
        return Put(`/msls/Project/End/${id}`, {});
    };


    /**
   * 新增
   */
    export var AddProject = (body: any): Promise<any> => {
        return Post(`/msls/Project/AddProject`, body);
    };

    /**
    * 获取跟踪记录
    */
    export var GetTracks = (id): Promise<any> => {
        return Get(`/msls/Project/GetTracks/${id}`, {});
    };

    /**
 * 获取字典数据
 */
    export var GetDicDetailList = (query: any): Promise<any> => {
        return Get(`/msls/DataDictionary/GetDicDetailList?${qs.stringify(query)}`, {});
    };

    /**
* 定向询价调整承运商
*/
    export var UpdateCarriers = (body: any): Promise<any> => {
        return Post(`/msls/Project/UpdateCarriers`, body);
    };

    /**
    * 一键否决所有报价
    */
    export var RejectAllQuote = (id: string): Promise<any> => {
        return Put(`/msls/Project/RejectAllQuote/${id}`, {});
    };


    /**
* 中标
*/
    export var Win = (body: any): Promise<any> => {
        return Post(`/msls/Project/Win`, body);
    };
    /**
* 取消中标
*/
    export var CancelWin = (body: any): Promise<any> => {
        return Post(`/msls/Project/CancelWin`, body);
    };

    /**
* 退回报价，让承运商重新报价
*/
    export var BackQuote = (body: any): Promise<any> => {
        return Post(`/msls/Project/BackQuote`, body);
    };

    /**
      * 一键催报
      */
    export var Urge = (id: string): Promise<any> => {
        return Post(`/msls/Project/Urge/${id}`, {});
    };

    /**
 * 导出
 */
    export var Export = (query: any): Promise<any> => {
        return Download(`/msls/Project/Export?${qs.stringify(query)}`, {});
    };

    export var GetContacters = (query: any): Promise<any> => {
        return Get(`/msls/Project/GetContacters?${qs.stringify(query)}`, {});
    };


}
